import React, {FC, createContext, useContext, useEffect} from 'react'
import {WithChildren} from '../helpers'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

type Props = {
  selectedLang: 'ar' | 'en'
}
const initialState: Props = {
  selectedLang: 'ar',
}

export function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      return JSON.parse(ls) as Props
    } catch (er) {
      console.error(er)
    }
  }
  return initialState
}

export function setLanguage(lang: string) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang}))
  if( document.location.pathname.startsWith('/c') && document.location.pathname != '/coming-soon' ){
    window.location.href = window.location.href
  }else if ( document.location.pathname.startsWith('/api-access/request') ){
    window.location.href = '/api-access/request'
  }else{
    window.location.reload()
  }
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

const getUserPreferredLang = (): 'ar' | 'en'  => {
  const supportedLangs = ['ar', 'en']
  const userLang = navigator.language.split('-')[0]
  //return supportedLangs.includes(userLang) ? (userLang as 'ar' | 'en') : 'ar'
  return 'ar'
}

const MetronicI18nProvider: FC<WithChildren> = ({children}) => {
  const lang = getConfig()

  useEffect(() => {
    if (!localStorage.getItem(I18N_CONFIG_KEY)) {
      const preferredLang = getUserPreferredLang()
      setLanguage(preferredLang)
    }
  }, [])

  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export {MetronicI18nProvider, useLang}
